// src/reducers/volume.js

import {
    GET_VOLUME_CONTRACTS,
    GET_VOLUME_CONTRACTS_RESPONSE,
    GET_VOLUME_CONTRACTS_ERROR,
    REGISTER_PRODUCT_BY_VOLUME,
    REGISTER_PRODUCT_BY_VOLUME_RESPONSE,
    REGISTER_PRODUCT_BY_VOLUME_ERROR,
    CLEAR_VOLUME_REGISTRATION_UI,
    CLEAR_VOLUME_REGISTRATION_ERROR,
} from './volumeRegistration.actions';
import { REHYDRATE } from 'redux-persist';
import { LOGOUT } from '../session/session.actions';

const initialState = {
    contracts: [],
    getContractsStatus: { loading: false, error: null },
    registerStatus: { error: false, loading: false, success: false, errorMessage: '' },
};

export default function volumeReducer(state = initialState, action) {
    switch (action.type) {
        case GET_VOLUME_CONTRACTS:
            return {
                ...state,
                getContractsStatus: { loading: true, error: null },
            };
        case GET_VOLUME_CONTRACTS_RESPONSE:
            return {
                ...state,
                contracts: action.response,
                getContractsStatus: { loading: false, error: null },
            };
        case GET_VOLUME_CONTRACTS_ERROR:
            return {
                ...state,
                getContractsStatus: { loading: false, error: action.error },
            };

        case REGISTER_PRODUCT_BY_VOLUME:
            return {
                ...state,
                registerStatus: { loading: true, error: null },
            };
        case REGISTER_PRODUCT_BY_VOLUME_RESPONSE:
            return {
                ...state,
                registerStatus: { loading: false, error: null, success: true },
            };
        case REGISTER_PRODUCT_BY_VOLUME_ERROR:
            return {
                ...state,
                registerStatus: {
                    loading: false,
                    error: true,
                    success: false,
                    errorMessage: action.error,
                },
            };
        case CLEAR_VOLUME_REGISTRATION_UI:
            return {
                ...state,
                registerStatus: { error: false, loading: false, success: false, errorMessage: '' },
            };
        case CLEAR_VOLUME_REGISTRATION_ERROR:
            return {
                ...state,
                registerStatus: { ...state.registerStatus, error: false, errorMessage: '' },
            };
        case LOGOUT:
            return { ...initialState };
        case REHYDRATE: {
            let incoming = action.payload;
            if (incoming) {
                return {
                    ...incoming.volumeRegistration,
                    validationStatus: initialState.validationStatus,
                    registerStatus: initialState.registerStatus,
                    downloadTransactionsStatus: initialState.downloadTransactionsStatus,
                    getContractsStatus: initialState.getContractsStatus,
                };
            } else {
                return state;
            }
        }
        default:
            return state;
    }
}
